module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak przyrodniczo-edukacyjny żółty.svg?dea531ed";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak przyrodniczo-edukacyjny żółty.svg
// module id = 2028
// module chunks = 0